define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/cookie-service/1.0.0/index'
], function riqAuthServiceModule(aoflModules, cookieService) {
  'use strict';
  var storeService = aoflModules.store;
  const SUBDOMAIN_REGEX = /.*\.(.*?\.(?:com|net))/;

  const getDomain = (hostname = location.hostname) => {
    const matches = SUBDOMAIN_REGEX.exec(hostname);
    if (matches === null) {
      return hostname;
    }

    return matches[1];
  };
  const SECURE = location.protocol === 'https:';
  const cookiesConfig = {
    secure: SECURE,
    domain: getDomain(),
    expires: 365
  };
  const riqAuthService = function riqAuthService(
    $timeout,
    riqApiService,
    riqAnalyticsService,
    riqUserStateService,
    riqProfileStateService,
    groupStateService
  ) {
    storeService.addState(riqUserStateService);
    storeService.addState(riqProfileStateService);
    storeService.addState(groupStateService);

    riqApiService.setApiEndpoints({
      loginAs: 'profile_swap'
    });

    var getPreviouslyLoggedInProfile = function getPreviouslyLoggedInProfile(
      group
    ) {
      var profileId = localStorage.getItem('riqPrivateActiveProfileId');
      var profile = group.profiles.filter(function(profile) {
        return profileId === profile.profileUuid;
      })[0];
      if (!profile) {
        localStorage.removeItem('riqPrivateActiveProfileId');
      }
      return profile ? profile : null;
    };

    function getGroupOwnerProfile(group) {
      return group.profiles.filter(function(profile) {
        return group.ownerUserUuid === profile.userUuid;
      })[0];
    }

    function isTeacherRole(role) {
      return role.toLowerCase().indexOf('teacher') > -1;
    }

    function groupHasOneProfile(group) {
      return group.profiles.length === 1;
    }

    function getActiveProfile(payload) {
      var profile;
      var group = payload.activeGroups.groups[0];
      var prevLoggedInProfile = getPreviouslyLoggedInProfile(group);
      var isTeacher = isTeacherRole(payload.role);
      var onlyOneProfile = groupHasOneProfile(group);
      if (prevLoggedInProfile) {
        return prevLoggedInProfile;
      }
      if (onlyOneProfile) {
        profile = group.profiles[0];
        return profile;
      }
      if (isTeacher) {
        return getGroupOwnerProfile(group);
      }
      return;
    }

    function formatOnboardingState(_onboardingSteps = [], _onboardingStep) {
      const onboardingSteps = _onboardingSteps.map(step =>
        step && step.name ? step.name : step
      );
      let onboardingStep =
        _onboardingStep && _onboardingStep.name
          ? _onboardingStep.name
          : _onboardingStep;

      return {onboardingSteps, onboardingStep};
    }

    function extractUserMeta(payload) {
      try {
        var userDetails = payload.userInfo.userDetails;
        var firstName = userDetails.firstName || '';
        var lastName = userDetails.lastName || '';
        var inactive = parseInt(userDetails.inactive, 10) || 0;
        var authenticated = isTeacherRole(payload.role);
        var ftue = parseInt(userDetails.ftue, 10) || 0;
        var completedMarketingSurvey = userDetails.heardAboutResponse ? 1 : 0;
        var completedParentExpectations = userDetails.hopesResponse ? 1 : 0;
        var teacherRewardsOptIn = isTeacherRole(payload.role)
          ? userDetails.teacherRewardsOptIn
          : false;
        const {onboardingSteps, onboardingStep} = formatOnboardingState(
          userDetails.onboardingSteps,
          userDetails.ftueStep
        );
        const geoipInfo = payload.geoipInfo || {};

        return {
          // @to-do Check why name is firstName.
          name: firstName,
          firstName: firstName,
          lastName: lastName,
          ftue: ftue,
          inactive: inactive,
          logoutDestination: '/',
          authenticated: authenticated,
          completedMarketingSurvey: completedMarketingSurvey,
          completedParentExpectations: completedParentExpectations,
          teacherRewardsOptIn,
          onboardingSteps,
          onboardingStep,
          geoipInfo
        };
      } catch (e) {
        return {};
      }
    }

    const getComponentsOverride = (payload, userId) => {
      try {
        return payload.abtestInfo[userId].ComponentOverride;
      } catch (e) {
        return {};
      }
    };

    // @todo Refactor this function to use decorators based on the payload
    var setInitialState = function setInitialState(payload) {
      // set the default profile
      var profile = getActiveProfile(payload);
      var group = payload.activeGroups.groups[0];
      var userMeta = extractUserMeta(payload);
      // eslint-disable-next-line no-undef
      var roles = payload.userInfo?.role || [];
      var userUpdateStoreCommit = {
        stateAlias: 'user',
        mutationId: 'update',
        payload: Object.assign(userMeta, {
          accountType: payload.accountType,
          usernameType: payload.usernameType,
          currentEmail: payload.currentEmail,
          groupUuid: group.groupUuid,
          userUuid: payload.userUuid,
          masterUserUuid: payload.masterUserUuid || payload.userUuid,
          // eslint-disable-next-line no-undef
          userDescription: roles[0]?.type,
          role: payload.role,
          route: payload.route,
          activeGroups: payload.activeGroups.groups,
          reader: profile,
          componentsOverride: getComponentsOverride(payload, payload.userUuid),
          geoipInfo: payload.geoipInfo
        })
      };

      if (profile) {
        localStorage.setItem('riqPrivateActiveProfileId', profile.profileUuid);
        return riqApiService
          .get('swapProfile', {profileUuid: profile.profileUuid})
          .then(function(profileData) {
            // eslint-disable-next-line no-undef
            const newUserDesc = profileData.tracking?.to?.userDescription;
            if (newUserDesc) {
              userUpdateStoreCommit.payload.userDescription = newUserDesc;
            }
            profile.role = profileData.role;
            storeService.commit([
              userUpdateStoreCommit,
              {
                stateAlias: 'profile',
                mutationId: 'setUserProfile',
                payload: profile
              }
            ]);
            return profileData;
          });
      }

      storeService.commit([
        userUpdateStoreCommit,
        {
          stateAlias: 'profile',
          mutationId: 'setUserProfile',
          payload: profile
        }
      ]);
      return profile;
    };

    this.auth = function riqAuth(token) {
      return riqApiService
        .get('validateSession', {token: token, platform: 'web'})
        .then(res => {
          const tokenCookie = cookieService.get('token');
          if (tokenCookie !== token) {
            cookieService.remove('token');
            cookieService.remove('token', cookiesConfig);
            cookieService.set('token', token, cookiesConfig);
          }
          localStorage.setItem('riqAuthToken', token);
          return res;
        })
        .then(setInitialState);
    };

    this.logout = function logout(logoutDestination) {
      const state = storeService.getState();
      logoutDestination = logoutDestination || state.user.logoutDestination;

      localStorage.removeItem('riqAuthToken');
      localStorage.removeItem('riqPrivateActiveProfileId');
      localStorage.removeItem('riqClassLoginLock');
      cookieService.remove('token');
      cookieService.remove('token', cookiesConfig);
      // We shouldnt care about errors for logging out
      return riqApiService
        .getMarketing('logoutUser')
        .then(function() {
          riqAnalyticsService.enqueueEvent(
            {
              eventType: 'com.aofl.readingiq.user.logout',
              payload: {
                username_type: state.user.usernameType,
                success: 'true',
                role: state.user.role
              }
            },
            true
          );

          return $timeout(500);
        })
        .then(function() {
          if (logoutDestination) {
            window.location = logoutDestination;
          } else {
            window.location = '/';
          }
        })
        .catch(function() {
          if (logoutDestination) {
            window.location = logoutDestination;
          } else {
            window.location = '/';
          }
        });
    };
  };

  return riqAuthService;
});
